// This file is generated from meta yaml file

import DockerIcon from 'icons/DockerIcon';
import LegoIcon from 'icons/LegoIcon';
import BrickPiIcon from 'icons/BrickPiIcon';
import Zigbee2MQTTIcon from 'icons/Zigbee2MQTTIcon';
import BisonIcon from 'icons/BisonIcon';
import CPPIcon from 'icons/CPPIcon';
import GcloudIcon from 'icons/GcloudIcon';
import ReactIcon from 'icons/ReactIcon';
import ElixirIcon from 'icons/ElixirIcon';
import PythonIcon from 'icons/PythonIcon';
import MaterialIcon from 'icons/MaterialIcon';
import React from 'react';
import BalenaIcon from 'icons/BalenaIcon';export default [
  {
    "title": "Portfolio",
    "category": "Extracurricular",
    "previewSrc": "projects/portfolio/preview.js",
    "imgSrc": "projects/portfolio/front.png",
    "footerIcons": [
      <GcloudIcon key={0} />,
      <ReactIcon key={1} />,
      <MaterialIcon key={2} />
    ],
    "id": "benshen98.github.io",
    "date": "2020-06-20T21:59:48Z",
    "sourceCode": "https://github.com/BenShen98/benshen98.github.io",
    "codeComposition": [
      {
        "color": "#f1e05a",
        "name": "JavaScript",
        "value": 60271
      },
      {
        "color": "#3572A5",
        "name": "Python",
        "value": 9773
      },
      {
        "color": "#e34c26",
        "name": "HTML",
        "value": 1901
      }
    ]
  },
  {
    "title": "Raft Consensus",
    "category": "Academic",
    "previewSrc": "projects/raft/preview.js",
    "imgSrc": "projects/raft/front.png",
    "footerIcons": [
      <ElixirIcon key={0} />
    ],
    "reportSrc": "projects/raft/raftReport.pdf",
    "webpageHref": null,
    "id": "raft",
    "date": "2020-02-11T10:26:01Z",
    "sourceCode": "https://github.com/BenShen98/raft",
    "codeComposition": [
      {
        "color": "#6e4a7e",
        "name": "Elixir",
        "value": 25954
      },
      {
        "color": "#427819",
        "name": "Makefile",
        "value": 1237
      },
      {
        "color": "#89e051",
        "name": "Shell",
        "value": 833
      }
    ]
  },
  {
    "title": "Probabilistic Localization",
    "category": "Academic",
    "previewSrc": "projects/robotics/preview.js",
    "imgSrc": "projects/robotics/front.gif",
    "footerIcons": [
      <BrickPiIcon key={0} />,
      <PythonIcon key={1} />,
      <LegoIcon key={2} />
    ],
    "id": "robotics",
    "date": "2019-10-16T17:49:03Z",
    "sourceCode": "https://github.com/BenShen98/robotics",
    "codeComposition": [
      {
        "color": "#3572A5",
        "name": "Python",
        "value": 87565
      }
    ]
  },
  {
    "title": "Smart Home",
    "category": "Extracurricular",
    "previewSrc": "projects/smart_home/preview.js",
    "imgSrc": "projects/smart_home/front.jpg",
    "footerIcons": [
      <DockerIcon key={0} />,
      <BalenaIcon key={1} />,
      <Zigbee2MQTTIcon key={2} />
    ],
    "id": "smart_home",
    "date": "2019-12-21T11:55:31Z",
    "sourceCode": "https://github.com/BenShen98/smart_home",
    "codeComposition": [
      {
        "color": "#f1e05a",
        "name": "JavaScript",
        "value": 13110
      },
      {
        "color": "#3572A5",
        "name": "Python",
        "value": 9755
      },
      {
        "color": "#89e051",
        "name": "Shell",
        "value": 5144
      },
      {
        "color": "#384d54",
        "name": "Dockerfile",
        "value": 2713
      }
    ]
  },
  {
    "title": "Real Time Concurrent Controller",
    "category": "Academic",
    "previewSrc": "projects/RTOS/preview.js",
    "imgSrc": "projects/RTOS/front.jpg",
    "reportSrc": "projects/RTOS/RTOSReport.pdf",
    "footerIcons": [
      <CPPIcon key={0} />
    ],
    "id": "RTOS-MotorControl-HashCompute",
    "date": "2020-03-04T15:30:01Z",
    "sourceCode": "https://github.com/BenShen98/RTOS-MotorControl-HashCompute",
    "codeComposition": [
      {
        "color": "#f34b7d",
        "name": "C++",
        "value": 31180
      }
    ]
  },
  {
    "title": "C90 Compiler",
    "category": "Academic",
    "previewSrc": "projects/compiler/preview.js",
    "imgSrc": "projects/compiler/front.png",
    "footerIcons": [
      <CPPIcon key={0} />,
      <BisonIcon key={1} />
    ],
    "id": "C90Compiler",
    "date": "2019-01-31T22:18:44Z",
    "sourceCode": "https://github.com/BenShen98/C90Compiler",
    "codeComposition": [
      {
        "color": "#f34b7d",
        "name": "C++",
        "value": 303541
      },
      {
        "color": "#6E4C13",
        "name": "Assembly",
        "value": 122112
      },
      {
        "color": "#4B6C4B",
        "name": "Yacc",
        "value": 15556
      },
      {
        "color": "#555555",
        "name": "C",
        "value": 10394
      },
      {
        "color": "#89e051",
        "name": "Shell",
        "value": 5685
      },
      {
        "color": "#DBCA00",
        "name": "Lex",
        "value": 5003
      },
      {
        "color": "#427819",
        "name": "Makefile",
        "value": 1640
      },
      {
        "color": "#b07219",
        "name": "Java",
        "value": 250
      },
      {
        "color": "#3572A5",
        "name": "Python",
        "value": 134
      }
    ]
  },
  {
    "title": "CPU Simulator",
    "category": "Academic",
    "previewSrc": "projects/mips/preview.js",
    "imgSrc": "projects/mips/front.png",
    "footerIcons": [
      <CPPIcon key={0} />
    ],
    "id": "mips",
    "date": "2018-10-23T21:26:05Z",
    "sourceCode": "https://github.com/BenShen98/mips",
    "codeComposition": [
      {
        "color": "#f34b7d",
        "name": "C++",
        "value": 32774
      },
      {
        "color": "#6E4C13",
        "name": "Assembly",
        "value": 10173
      },
      {
        "color": "#427819",
        "name": "Makefile",
        "value": 4730
      },
      {
        "color": "#89e051",
        "name": "Shell",
        "value": 1294
      }
    ]
  }
]
